import { ref, watch } from '@vue/composition-api';

export default function useShareTypeHandler(props, emit) {
    
    const shareTypeLocal = ref(JSON.parse(JSON.stringify(props.shareType.value)));

    const resetShareTypeLocal = () => {
        shareTypeLocal.value = JSON.parse(JSON.stringify(props.shareType.value));
    };

    watch(props.shareType, () => {
        resetShareTypeLocal();
    });

    const onSubmit = () => {
        const shareTypeData = JSON.parse(JSON.stringify(shareTypeLocal));

        // * If event has id => Edit Event
        // Emit event for add/update event
        if (props.shareType.value.id) emit('update-share-type', shareTypeData.value);
        else emit('add-share-type', shareTypeData.value);
    };

    return {
        shareTypeLocal,
        resetShareTypeLocal,

        // UI
        onSubmit,
    };
}
